module.exports = __webpack_public_path__ + "static/to-do-app-cover-c8acc5b320aa75ad13605da2fe110363.png";